namespace GpScot.PromoGroups {

    export function init() {
        childCount();
    }

    enum CLASSES {
        Element = 'nhssf-promo-group',
        ElementSingle = 'nhssf-promo-group--single',
        ElementMulti = 'nhssf-promo-group--multi',
    }

    const childCount = () => {
        document.querySelectorAll('.' + CLASSES.Element)
            .forEach((el) => {
                el.childElementCount > 1 ?
                    el.classList.add(CLASSES.ElementMulti) :
                    el.classList.add(CLASSES.ElementSingle);
            });
    };
}

